import { useContext, useEffect, useCallback, useState } from 'react';
import { FabricContext } from '@context/FabricContext';
import { useSelectedMVComment } from '@hooks';
import { useAssetViewerState } from '@hooks/useAssetViewerState';

export default function useHasAnnotations() {
  const selectedComment = useSelectedMVComment();
  const { selectedCommentId } = useAssetViewerState();
  const { canvas, getObjects } = useContext(FabricContext);
  const [has, setHas] = useState<boolean>(false);

  const syncFromCanvas = useCallback(() => {
    setHas(getObjects().length > 0);
  }, [getObjects]);

  const isDraftComment =
    selectedCommentId === 'new' || selectedCommentId === 'reply';

  useEffect(() => {
    if (isDraftComment) {
      syncFromCanvas();
      return;
    }
    if (selectedComment?.annotations) {
      setHas(!!selectedComment.annotations.length);
      return;
    }
    syncFromCanvas();
  }, [isDraftComment, selectedComment, syncFromCanvas]);

  useEffect(() => {
    if (!canvas) return;
    syncFromCanvas();
    canvas.on('canvas:cleared', syncFromCanvas);
    canvas.on('object:history:add', syncFromCanvas);
    canvas.on('object:history:remove', syncFromCanvas);
    return () => {
      canvas.off('canvas:cleared', syncFromCanvas);
      canvas.off('object:history:remove', syncFromCanvas);
      canvas.off('object:history:add', syncFromCanvas);
    };
  }, [canvas, syncFromCanvas]);

  return has;
}
